export default { 
  Login: require('./Login').default,
  ForgotPassword: require('./ForgotPassword').default,
  PasswordReset: require('./PasswordReset').default,
  PasswordChanged: require('./PasswordChanged').default,
  UpdatePassword: require('./UpdatePassword').default,
}